// const BASE_URL =
//   process.env.BASE_URL ||
//   "https://s-auditsense-staging-1086719075712.us-central1.run.app";
const BASE_URL =
  "https://s-auditsense-staging-1086719075712.us-central1.run.app";
const LOCAL = `${BASE_URL}/v1`;
// const LOCAL = `http://localhost:3000/v1`;

export const USER = {
  LOGIN: `${LOCAL}/users/login`,
  UPDATE_PROFILE: `${LOCAL}/users`,
  UPDATE_PASSWORD: `${LOCAL}/users/reset`,
  FORGOT_PASSWORD: `${LOCAL}/users/forgotPassword`,
  VERIFY_RESET_TOKEN: `${LOCAL}/users/verifyResetToken`,
  RESET_PASSWORD_WITH_TOKEN: `${LOCAL}/users/resetPasswordWithToken`,
};

export const SUPPLIERS = {
  LIST: `${LOCAL}/suppliers/organisations/<ORGANISATION_ID>`,
  SEARCH: `${LOCAL}/suppliers/organisations/<ORGANISATION_ID>/search`,
  GET_BY_ID: `${LOCAL}/suppliers/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>`,
  UPDATE_BY_ID: `${LOCAL}/suppliers/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>`,
};

export const FACTORIES = {
  LIST: `${LOCAL}/factories/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>`,
  SEARCH: `${LOCAL}/factories/organisations/<ORGANISATION_ID>/search`,
  GET_LIST_BY_ORGANISATION_ID: `${LOCAL}/factories/organisations/<ORGANISATION_ID>`,
  GET_BY_ID: `${LOCAL}/factories/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/factories/<FACTORY_ID>`,
  UPDATE_BY_ID: `${LOCAL}/factories/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/factories/<FACTORY_ID>`,
  GET_TRACEABILITY_FACILITIES_BY_SUPPLIER: `${LOCAL}/factories/traceability/suppliers/<SUPPLIER_ID>`,
};

export const AUDITS = {
  LIST: `${LOCAL}/audits/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>`,
  GET_BY_ID: `${LOCAL}/audits/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/factories/<FACTORY_ID>/audits/<AUDIT_ID>`,
  UPDATE_BY_ID: `${LOCAL}/audits/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/factories/<FACTORY_ID>/audits/<AUDIT_ID>`,
  UPLOAD_REPORT: `${LOCAL}/audits/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/factories/<FACTORY_ID>/audits/<AUDIT_ID>/upload`,
  PROCESS_REPORT: `${LOCAL}/audits/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/factories/<FACTORY_ID>/audits/<AUDIT_ID>/process`,
  REGENERATE_CAP: `${LOCAL}/audits/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/factories/<FACTORY_ID>/audits/<AUDIT_ID>/regenerateCap`,
  DELETE_CAP_DETAILS_BY_ID: `${LOCAL}/audits/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/factories/<FACTORY_ID>/audits/<AUDIT_ID>/capdetails/<FINDING_ID>`,
  GET_LIST_OF_AUDITS_IN_CAP_MANAGEMENT: `${LOCAL}/audits/suppliers/<SUPPLIER_ID>/capmanagement`,
  GET_RESOURCES: `${LOCAL}/audits/resources`,
};
export const CAP_MANAGEMENT = {
  UPDATE: `${LOCAL}/capmanagements/audits/<AUDIT_ID>/issues`,
  SET_ADDITIONAL_CONTEXT_FOR_PROOF: `${LOCAL}/capmanagements/audits/<AUDIT_ID>/issues/<ISSUE_ID>/upload/context`,
  UPLOAD_PROOF: `${LOCAL}/capmanagements/audits/<AUDIT_ID>/issues/<ISSUE_ID>/upload`,
};
export const ORGANISATIONS = {
  GET_RISK_CHART_DATA: `${LOCAL}/organisations/<ORGANISATION_ID>/chart`,
  GET_RESOURCES: `${LOCAL}/organisations/<ORGANISATION_ID>/resources`,
};

export const ANALYTICS = {
  GET_URL: `${LOCAL}/analytics/organisations/<ORGANISATION_ID>/`,
};

export const NOTIFICATIONS = {
  SEND_NOTE: `${LOCAL}/notifications/organisations/<ORGANISATION_ID>/notes`,
};

export const PRODUCTS = {
  CREATE_AND_GET_PRODUCT: `${LOCAL}/products/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/form`,
  GET_AND_UPDATE_FORM_BY_ID: `${LOCAL}/products/form/<FORM_ID>`,
  UPLOAD_FILE: `${LOCAL}/products/form/<FORM_ID>/sections/<SECTION_ID>/upload`,
  ADD_TRADER_SECTION: `${LOCAL}/products/form/<FORM_ID>/trader-sections`,
  DELETE_TRADER_SECTION: `${LOCAL}/products/form/<FORM_ID>/trader-sections/<TRADER_ID>`,
  DELETE_FILE: `${LOCAL}/products/organisations/<ORGANISATION_ID>/suppliers/<SUPPLIER_ID>/forms/<FORM_ID>/files/<FILE_ID>`,
};

export const WIP = {
  // WIP Reports endpoints (new structure)
  GET_WIP_REPORTS: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/reports`,
  GET_WIP_REPORT_BY_ID: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/reports/<WIP_REPORT_ID>`,
  UPDATE_WIP_ITEMS_BY_REPORT: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/report/<WIP_ID>/items`,

  // WIP Items endpoints
  IMPORT: `${LOCAL}/wip/import`,
  GET_WIP_ITEMS: `${LOCAL}/wip/organisation/<ORGANISATION_ID>`,
  GET_WIP_ITEMS_DETAILED: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/items-detailed`, // Excel-style view with multiple items
  GET_WIP_ITEM: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/item/<WIP_ITEM_ID>`,
  UPDATE_WIP_ITEM: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/item/<WIP_ITEM_ID>`,

  GET_ITEMS_BY_REPORT_ID: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/report/<WIP_REPORT_ID>/items`,

  // Stage definitions
  GET_STAGE_DEFINITIONS: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/stage-definitions`,

  // Notification endpoints
  GET_NOTIFICATIONS: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/notifications`,
  GET_NOTIFICATION_COUNT: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/notifications/count`,
  MARK_NOTIFICATION_READ: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/notifications/<NOTIFICATION_ID>/read`,
  MARK_ALL_NOTIFICATIONS_READ: `${LOCAL}/wip/organisation/<ORGANISATION_ID>/notifications/read-all`,

  // Past-due endpoint
  GET_PAST_DUE: `${LOCAL}/wip/past-due`,
};
